import React from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";
import useSWR from "swr";
import { MaterialApiUrls } from "../../../Api/Auth/ApiUrls";
import Tabs from "../../../Components/Common/Tabs";
import { materialSubscriptionTabsData } from "../../../data/SidebarData";

const SubscriptionMaterials = () => {
  const { data } = useSWR(MaterialApiUrls.list(""));

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={materialSubscriptionTabsData} />
      <StaticPageForm
        title="Subscription Materials"
        typeData={data}
        type="materials"
        filter="subscription"
        subscription
        category={"civil"}
        promo
      />
    </div>
  );
};

export default SubscriptionMaterials;
